import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  bannerMessages: [],
};

const sideCoreContentSlice = createSlice({
  name: "sideCoreContent",
  initialState,
  reducers: {
    setSideCoreBannerMessages: (state, action) => {
      state.bannerMessages = action.payload;
    },
  },
});

export const { setSideCoreBannerMessages } = sideCoreContentSlice.actions;
export const sideCoreContentReducer = sideCoreContentSlice.reducer;
